<template>
    <div>
        <team-blazon-loader :settings="settings" :shape="settings.shape" :key="settings.shape" />
    </div>
</template>

<script>

    import TeamBlazonLoader from './TeamBlazonLoader';

    export default {
        name: 'TeamBlazonView',
        components: { TeamBlazonLoader },
        props: {
            settings: {
                type: Object,
                required: true,
            },
        },
    }
</script>
<style type="text/css">
    svg {
        width: 100%;
        max-width: 205px;
    }
    .blazon-container {
        display: inline-block;
    }
</style>
